<div class="ai-reco-card" [ngClass]="{ 'ai-reco-card--floating': floating }" role="region" aria-label="AI assistant summary" (click)="onCardClick($event)">
  <div class="ai-reco-card__icon">💡</div>
  <div class="ai-reco-card__body">
    <div class="ai-reco-card__title">{{ title }}</div>
  <a class="ai-reco-card__link" href="javascript:void(0)" (click)="onCardClick($event)">{{ ctaText }}</a>
  <button class="ai-reco-close" (click)="onDismiss($event)" aria-label="Dismiss recommendation">✕</button>
  </div>
  <div class="ai-reco-card__border"></div>
</div>
